import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-excel-file-type',
  templateUrl: './excel-file-type.component.html',
  styleUrls: ['./excel-file-type.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExcelFileTypeComponent extends DialogDefinitionEditorBase implements OnInit, AfterViewInit {
  optionItems: any [];
  images: string[] = [];
  texts: string[] = [];
  instructions: string[] = [];
  selectedId = 0;
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.optionItems = this.dialogField.options;
    for (const optionItem of this.optionItems) {
      this.images.push(optionItem['thumbnails']);
      this.texts.push(optionItem['text']);
      this.instructions.push(optionItem['instruction']);
    }
  }
  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.selectedId = this.optionItems.findIndex(x => x.id === this.dialogField.value);
  }

  onClick(id: number) {
    console.log('ExcelFileTypeComponent type selection clicked');
    if (this.selectedId === id) return;
    this.selectedId = id;
    this.dialogField.value = this.optionItems[id].id;
    super.onFormValueChange(this.dialogField.value);
  }
}
